import React from "react";

const PrimaryInput = ({ onValueChange, placeHolder, ...props }) => {
  return (
    <input
      className=" relative  w-full bg-surface py-2 px-3 border rounded placeholder:text-placeholder text-[14px] leading-6 text-gray-primary outline-primary-hover"
      type="text"
      onChange={(e) => onValueChange(e.target.value)}
      placeholder={placeHolder} //"Type tag name here"
      {...props}
    />
  );
};

export { PrimaryInput };
